module.exports = __webpack_public_path__ + "static/media/ticket-enabled.b2f8c367.svg";